module.exports = __webpack_public_path__ + "img/91_14.c88f360e.png";